import { astStore, dataStore } from '../../store';
import { DataSources } from '../../store/ast/ast.types';
/**
 * 计算每个数据源的层级（基于关系图）
 * @param dataSources 数据源配置
 * @returns Map<数据源prop, 层级>
 */
export function getDataSourceLevel(dataSources: DataSources): Map<string, number> {
  const levels = new Map<string, number>();
  const edges = dataSources.relationship;
  const items = dataSources.items;

  // 初始化所有数据源的层级为0（无依赖的顶级数据源）
  for (const item of items) {
    levels.set(item.prop, 0);
  }

  // 计算依赖层级
  let changed = true;
  while (changed) {
    changed = false;
    for (const edge of edges) {
      const sourceLevel = levels.get(edge.source) || 0;
      const targetLevel = levels.get(edge.target) || 0;
      const expectedLevel = sourceLevel + 1;

      if (targetLevel < expectedLevel) {
        levels.set(edge.target, expectedLevel);
        changed = true;
      }
    }
  }

  return levels;
}

/**
 * 根据数据源获取表单结构
 * @param compDataSource 
 * @returns 
 */
export const getFormListSetting = (compDataSource) => {
  let dataSource = astStore.state.dataSources.items.find(it => it.prop === compDataSource)
  return dataStore.state.formList.find(it => it._id === dataSource?.formId)
}

/**
 * 根据 prop 查找数据及其关系
 * @param {Object} data - 原始数据对象，包含 items 和 relationship
 * @param {string} prop - 要查找的 prop 值
 * @returns {Object} - 包含找到的数据项及其子项和关系的对象
 */
export const findDataWithRelationships = (data, prop) => {
  // 1. 首先找到目标项
  const targetItem = data.items.find(item => item.prop === prop);
  if (!targetItem) {
    return { items: [], relationship: [] };
  }

  // 2. 初始化结果集，包含目标项
  const result = {
    items: [targetItem],
    relationship: []
  };

  // 3. 递归查找所有子项
  function findChildren(parentProp) {
    // 查找所有以 parentProp 为 source 的关系
    const childRelations = data.relationship.filter(rel => rel.source === parentProp);
    
    childRelations.forEach(rel => {
      // 检查是否已经处理过这个关系
      if (!result.relationship.some(r => r.source === rel.source && r.target === rel.target)) {
        // 添加到关系结果中
        result.relationship.push(rel);
        
        // 查找对应的子项
        const childItem = data.items.find(item => item.prop === rel.target);
        if (childItem && !result.items.some(item => item.prop === childItem.prop)) {
          result.items.push(childItem);
          // 递归查找子项的子项
          findChildren(childItem.prop);
        }
      }
    });
  }

  // 从目标 prop 开始查找
  findChildren(prop);

  return result;
}